var React = require('react');

function SubNavArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.8995 4.2426v2.8285L3.4853 5.6569l1.4142-1.4143zM.6569 2.8284V0l5.6568 5.6569L.657 11.3137V8.4853l2.8284-2.8284L.6569 2.8284zm4.2426 1.4142v2.8285L3.4853 5.6569l1.4142-1.4143zM.6569 2.8284V0l5.6568 5.6569L.657 11.3137V8.4853l2.8284-2.8284L.6569 2.8284z"}));
}

SubNavArrow.defaultProps = {"width":"7","height":"12","viewBox":"0 0 7 12"};

module.exports = SubNavArrow;

SubNavArrow.default = SubNavArrow;
